import { render, staticRenderFns } from "./TrComics.vue?vue&type=template&id=1c0285ac&scoped=true&"
import script from "./TrComics.vue?vue&type=script&lang=js&"
export * from "./TrComics.vue?vue&type=script&lang=js&"
import style0 from "./TrComics.vue?vue&type=style&index=0&id=1c0285ac&lang=scss&scoped=true&"
import style1 from "./TrComics.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./TrComics.vue?vue&type=style&index=2&id=1c0285ac&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0285ac",
  null
  
)

export default component.exports